import { makeInstallableAppFromSPIInstallableAddonAndMarketplaceAppData } from '../../records/InstallableApp';
import { makeInstallableAppByKeyIdentifier } from '../../records/InstallableAppIdentifier';
import { makeInstallableAppUpgradeInstallMode } from '../../records/InstallMode/InstallableAppUpgradeInstallMode';
import getSPI from '../../services/SPI';
import { retrieveAppDataByKey } from './AppDataRetrieval';
import { doSetInstallMode } from './Installation';
import { updateInstalledAppsPostInstall } from './postInstallActions';
export const FINISH_FETCH_INSTALLABLE_APP_FOR_UPGRADE = 'INSTALLATION_FINISH_FETCH_INSTALLABLE_APP_FOR_UPGRADE';
export const FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR = 'INSTALLATION_FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR';
export const START_UPGRADE_APP = 'INSTALLATION_START_UPGRADE_APP';
export const FINISH_UPGRADE_APP = 'INSTALLATION_FINISH_UPGRADE_APP';
export const UPGRADE_APP_ERROR = 'INSTALLATION_UPGRADE_APP_ERROR';
const finishFetchInstallableAppForUpgrade = _ref => {
  let {
    installableAppByKeyId,
    installableAppToUpgradeTo
  } = _ref;
  return {
    type: FINISH_FETCH_INSTALLABLE_APP_FOR_UPGRADE,
    installableAppByKeyId,
    installableAppToUpgradeTo
  };
};
const fetchInstallableAppForUpgradeError = _ref2 => {
  let {
    error,
    installableAppByKeyId
  } = _ref2;
  return {
    type: FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR,
    error,
    installableAppByKeyId
  };
};
const startUpgradeApp = _ref3 => {
  let {
    installableAppByKeyId
  } = _ref3;
  return {
    type: START_UPGRADE_APP,
    installableAppByKeyId
  };
};
const finishUpgradeApp = _ref4 => {
  let {
    context,
    installableAppByKeyId
  } = _ref4;
  return {
    type: FINISH_UPGRADE_APP,
    context,
    installableAppByKeyId
  };
};
const upgradeAppError = _ref5 => {
  let {
    context,
    error,
    installableAppByKeyId
  } = _ref5;
  return {
    type: UPGRADE_APP_ERROR,
    context,
    installableAppByKeyId,
    error
  };
};
export const doInitiateUpgradeInstallModeForInstalledApp = _ref6 => {
  let {
    mpacBaseUrl,
    installedApp
  } = _ref6;
  return dispatch => {
    const installableAppByKeyId = makeInstallableAppByKeyIdentifier({
      key: installedApp.details.key
    });
    dispatch(doSetInstallMode({
      installMode: makeInstallableAppUpgradeInstallMode({
        installedApp,
        installableAppByKeyId
      })
    }));
    retrieveAppDataByKey({
      installableAppByKeyId,
      mpacBaseUrl
    }).then(_ref7 => {
      let {
        installableAddon,
        marketplaceApp
      } = _ref7;
      installableAddon.map(installableAppToUpgradeTo => makeInstallableAppFromSPIInstallableAddonAndMarketplaceAppData(installableAppToUpgradeTo, marketplaceApp, mpacBaseUrl)).fold(error => {
        dispatch(fetchInstallableAppForUpgradeError({
          error,
          installableAppByKeyId
        }));
      }, installableAppToUpgradeTo => {
        dispatch(finishFetchInstallableAppForUpgrade({
          installableAppToUpgradeTo,
          installableAppByKeyId
        }));
      });
    }).catch(console.error.bind(console));
  };
};
export const doUpgradeApp = _ref8 => {
  let {
    context,
    hostConfig,
    installedApp,
    installableAppByKeyId,
    installableAppToUpgradeTo
  } = _ref8;
  return dispatch => {
    let newVersion;
    dispatch(startUpgradeApp({
      installableAppByKeyId
    }));
    if (installableAppToUpgradeTo.details.version) {
      newVersion = installableAppToUpgradeTo.details.version;
      return getSPI().upgradeAddon({
        addon: installedApp._original,
        contextId: context.id,
        newVersion
      }).then(() => {
        dispatch(finishUpgradeApp({
          context,
          installableAppByKeyId
        }));
        updateInstalledAppsPostInstall(dispatch, context, hostConfig);
      }, error => {
        handleError(dispatch, context, installableAppByKeyId, 'upgradeAddon could not be executed as there was no version on the installableApp', error);
      });
    } else {
      handleError(dispatch, context, installableAppByKeyId, 'upgradeAddon could not be executed as there was no version on the installableApp');
      return Promise.resolve();
    }
  };
};
function handleError(dispatch, context, installableAppByKeyId, contextualError, specificError) {
  console.error(contextualError, specificError);
  dispatch(upgradeAppError({
    context,
    error: specificError || contextualError,
    installableAppByKeyId
  }));
}